import {Component, Inject} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FieldUiDataObj} from "../../../../../generated/generated-core.model";
import {MxFormCustomizerEvent, SubmitFn} from "../../../mx-form/services/mx-form-fields-builder.service";
import {MxCustomizer} from "../../../../mx-customizer";

export class MxAdvancedFiltersDialogData {
    advancedFields: Array<FieldUiDataObj>;
}
@Component({
    selector: 'mx-advanced-filters',
    standalone: false,
    template: '<mx-object-form (customize)="onCustomize($event)"></mx-object-form>'
})
export class MxGraphAdvancedFiltersDialogComponent implements MxCustomizer<MxFormCustomizerEvent> {

    constructor(private dialogRef: MatDialogRef<MxGraphAdvancedFiltersDialogComponent>,
                @Inject(MAT_DIALOG_DATA) private data: MxAdvancedFiltersDialogData) {
    }
    onCustomize(event: MxFormCustomizerEvent) {
        event
            .customizeFieldsDataConfig({
                metaObject: {
                    fieldsData: this.data.advancedFields
                }
            })
            .customizeActions({
                submit: {
                    visible: true,
                    text: 'Apply'
                },
                cancel: {
                    text: 'Cancel',
                    visible: false
                }
            })
            .customizeProps({
                showNavigation: false,
                submitFunction: this.ok
            });
    }

    private ok: SubmitFn = (form: FormGroup) => {
        this.dialogRef.close(form.getRawValue());
    }
}
